/* La Caza Cali — "tap to turn the lights off" nudge (round 4)
 *
 * Once per browsing session, when the FIRST light switch on a page
 * (PDP light-preview switch, homepage master switch, or collection-page
 * master switch — see snippets/lacaza-light-preview.liquid and
 * snippets/lacaza-light-switch-bar.liquid) scrolls at least 60% into
 * view, wait ~900ms then:
 *   - nudge the knob toward OFF three times (skipped under
 *     prefers-reduced-motion)
 *   - show a small paper pill above the switch: "Tap to turn the
 *     lights off" (locale lacaza_light.hint)
 * The pill fades out after 4s, or immediately the first time ANY
 * switch on the page is toggled. It never appears again this session.
 * Wrapped in try/catch since sessionStorage can throw (private mode,
 * blocked storage, etc).
 *
 * Background-tab safety (round 5): the session flag is written only
 * once the pill is actually inserted into the DOM (inside showHint()),
 * never at the moment the switch crosses the visibility threshold. If
 * the switch reaches 60% visibility while the tab is hidden (a very
 * common way to land on the site — opened from Instagram/a link into a
 * background tab), the 900ms timer doesn't start until the tab
 * actually becomes visible, so a background-tab load never silently
 * burns the once-per-session hint.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lacazaLightHintShown';
  var SWITCH_SELECTOR = '[data-light-preview] .lp__switch, [data-lights-master-switch] .lp__switch';

  function alreadyShown() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markShown() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function removePill(pill) {
    if (!pill || !pill.parentNode) return;
    pill.classList.add('lp__hint--out');
    window.setTimeout(function () {
      if (pill.parentNode) pill.parentNode.removeChild(pill);
    }, 220);
  }

  function showHint(btn) {
    var knob = btn.querySelector('.lp__knob');
    var text = btn.getAttribute('data-hint-text') || 'Tap to turn the lights off';

    var pill = document.createElement('div');
    pill.className = 'lp__hint';
    pill.setAttribute('role', 'status');
    pill.textContent = text;

    // Anchor the pill to the switch button itself so it tracks the
    // knob's resting side (right, since default state is ON) without
    // needing to know the button's on-page position.
    var anchor = btn.parentElement; // .lp__bar or .lp__head wrapper
    if (getComputedStyle(btn).position === 'static') {
      btn.style.position = 'relative';
    }
    btn.appendChild(pill);
    // Only now — the pill is actually in the DOM — burn the once-per-
    // session flag. Doing this earlier (e.g. when the switch first
    // crosses the visibility threshold) would mark a background-tab
    // visitor as "shown" despite never seeing it (see file header).
    markShown();

    // Force layout then fade the pill in (starts at opacity:0 in CSS).
    window.requestAnimationFrame(function () {
      pill.classList.add('lp__hint--in');
    });

    if (!prefersReducedMotion() && knob) {
      knob.classList.add('lp__knob--nudge');
      knob.addEventListener('animationend', function onEnd() {
        knob.classList.remove('lp__knob--nudge');
        knob.removeEventListener('animationend', onEnd);
      });
    }

    var autoHide = window.setTimeout(function () {
      removePill(pill);
    }, 4000);

    // Dismiss immediately on the FIRST toggle of ANY switch on the page.
    function onAnyToggle() {
      window.clearTimeout(autoHide);
      removePill(pill);
      document.querySelectorAll(SWITCH_SELECTOR).forEach(function (b) {
        b.removeEventListener('click', onAnyToggle);
      });
    }
    document.querySelectorAll(SWITCH_SELECTOR).forEach(function (b) {
      b.addEventListener('click', onAnyToggle, { once: true });
    });
  }

  function init() {
    if (alreadyShown()) return;
    var switches = document.querySelectorAll(SWITCH_SELECTOR);
    if (!switches.length) return;
    if (!('IntersectionObserver' in window)) return;

    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      if (fired) return;
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          fired = true;
          io.disconnect();
          var target = entry.target;

          function startTimer() {
            window.setTimeout(function () {
              showHint(target);
            }, 900);
          }

          // A visitor can easily land here with the tab backgrounded
          // (opened from Instagram/a link into a new background tab).
          // The switch can still cross the IO threshold while hidden,
          // but starting the 900ms timer now would very likely resolve
          // to a pill nobody ever saw. Wait for the tab to actually
          // become visible before starting the clock.
          if (document.hidden) {
            document.addEventListener('visibilitychange', function onVisible() {
              if (document.hidden) return;
              document.removeEventListener('visibilitychange', onVisible);
              startTimer();
            });
          } else {
            startTimer();
          }
          break;
        }
      }
    }, { threshold: [0, 0.6, 1] });

    switches.forEach(function (btn) {
      io.observe(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
